<template>
  <div class="home-page">
    <el-container>
      <el-aside class='x-flex' style='width: unset;position: relative;'>
        <!-- 主菜单 -->
        <div class="main-menu" style="background-color: #242f43">
          <div class="x-flex x-w100p x-row-center x-p-20 x-p-b-10"><img src="../assets/img/logo.png" alt=""></div>
          <div class="main-menu-top-level">
            <ul class="infinite-list">
              <li @mouseover="mouseover(i)" v-for="(i, index) in navList" class="infinite-list-item x-p-l-6"
                :class="{'main-menu-style':i.select || i.label==hoverActive }" @click="navListClick(i)" :key="index">
                <span class="block-element iconfont x-p-l-5" :class="i.icon"></span>
                {{ i.label }}
              </li>
            </ul>
          </div>
        </div>

        <!-- 固定子菜单 点击显示  -->
        <div class="bgc-f x-w130 x-h100p x-bd-right" style="overflow-x: hidden;" v-if='clickDisplaySub'>
          <div class="c-0 x-text-l x-m-l-20 x-p-t-10 x-p-b-6 x-font-15  ">{{ fixSubTitle }}导航</div>
          <el-menu @open="" @close="" :default-openeds="openeds" :default-active="activerouter">
            <el-submenu v-for="(item,index) in fixSubNavList" :index="String(item.id)" :key="item.id">
              <template slot="title">
                <span style='color:#999999'>{{item.show_label ||  item.label}}</span>
              </template>
              <el-menu-item v-for="(item1,index1) in item.children" :index="String(item1.id)" :key="item1.id"
                :class="item1.select?'is-active':''" @click="subNavItemClick(item1)">{{ item1.show_label || item1.label}}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>

        <!-- 悬浮子菜单 鼠标移动该盒子显示隐藏   highlight-current 高光  moveDisplaySub-->
        <div class="bgc-f x-w130 x-h100p x-bd-right"
          style="overflow-x: hidden;position: absolute;left: 89px;top:0px;z-index: 99;" v-if='moveDisplaySub '
          @mouseleave="mouseleave" @mouseover="hoverMouseover">
          <!-- && clickDisplaySub != true -->
          <div class="c-0 x-text-l x-m-l-20 x-p-t-10 x-p-b-6 x-font-15  ">{{ floatSubTitle }}导航</div>
          <el-menu @open="" @close="" :default-openeds="openeds" :default-active="activerouter">
            <el-submenu v-for="(item,index) in floatSubNavList" :index="String(item.id)" :key="item.id">
              <template slot="title">
                <span style='color:#999999'>{{item.show_label ||item.label}}</span>
              </template>
              <el-menu-item v-for="(item1,index1) in item.children" :index="String(item1.id)" :key="item1.id"
                :class="item1.select?'is-active':''" @click="subNavItemClick(item1)">{{item1.show_label ||item1.label}}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-aside>
      <el-container>
        <!-- 头部 -->
        <el-header class="bgc-f x-d-flex x-row-between">
          <!-- 面包屑导航 -->
          <div class="x-lh-60">
            <span @click="fBreadcrumbRoter" :class="api.smCom.fSmIsEmpty(breadcrumbPath)?'':'breadcrumbHover'">
              {{breadcrumb}}
            </span>
            <span v-if="!api.smCom.fSmIsEmpty(breadcrumbSub)">{{breadcrumbSub}}</span>
          </div>
          <!-- 用户登录后显示的信息 -->
          <div class="x-d-flex x-h30 x-m-t-15">
            <div class="x-d-flex x-p-r-15">
              <x-button v-if='$store.state.ws_yn == "Y"' width='150px' margin_right='10px' title='通知设备端信息更新'
                @click.native='fSendMqtt' bgc='#fff' color='#242424' border='1px solid #E6E8EB'>
              </x-button>
              <div v-if="$store.state.softVer == '零售'">
                <x-button width='100px' border='1px solid #FF4646' bgc='#fff' color='#FF4646'
                  @click.native="fGoDownLoad">零售端下载
                </x-button>
              </div>
              <div class="x-p-l-10 x-cur-poi x-p-5" @click="smsRechargePop = true">
                <img class="x-w20 x-h20" src="../assets/img/indexSms.png" alt="">
              </div>
              <smsRecharge :isShow="smsRechargePop" @cencal='smsRechargePop=false'></smsRecharge>
              <!-- <div class="x-p-l-10 x-cur-poi x-p-5">
                <img class="x-w20 x-h20" src="../assets/img/xin.png" alt="">
              </div> -->
              <div class="x-p-l-10  x-p-5">
                <img class="x-w20 x-h20" src="../assets/img/zhuo.png" alt="">
              </div>
              <div class="x-p-l-2 x-lh-30">
                {{$store.state.smSellAdmin.compName}}
              </div>
            </div>
            <div class="x-d-flex x-p-r-15">
              <div class="x-w30 x-h30 x-bd-ra-50p" style="overflow: hidden;">
                <img class="x-w100p x-h100p" :src="imagesB" alt="">
              </div>
              <div class="x-p-l-2 x-lh-30">
                {{$store.state.smSellAdmin.shMallName}}
                ({{$store.state.smSellAdmin.shMallId}})
              </div>
            </div>
            <div class="x-d-flex x-p-r-15">
              <div class="x-w30 x-h30 x-bd-ra-50p" style="overflow: hidden;">
                <img class="x-w100p x-h100p" :src="imagesA" alt="">
              </div>
              <el-dropdown trigger="click" @visible-change="clickxw">
                <div class="x-m-l-2 x-lh-30 x-cur-poi x-d-flex">
                  {{$store.state.smSellAdmin.userName}}
                  ({{$store.state.smSellAdmin.userId}})
                  <div class="x-p-l-5">
                    <span class="el-icon-arrow-down"
                      :class="{'rotate':rotation == true,'rotates':rotation == false}"></span>
                  </div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="Change">修改密码</el-dropdown-item>
                  <el-dropdown-item @click.native='fLoginOut'>退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <!-- 修改密码 -->
        <el-dialog class="manage" width="400px" :visible.sync="changePassword">
          <div class="x-w100p x-h50 x-lh-32 x-d-flex x-p-10-15 x-bd-bottom">
            <div class="x-lh-32 x-font-14 f600 c-80">修改密码</div>
          </div>
          <div class="x-w100p x-p-20">
            <!-- 旧密码 -->
            <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
              <div class="x-w70 x-d-flex x-row-right x-p-r-10">
                <div>旧密码</div>
              </div>
              <div class="x-flex-1 x-w100p">
                <el-input v-model="oldPassword" placeholder=""></el-input>
              </div>
            </div>
            <!-- 新密码 -->
            <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
              <div class="x-w70 x-d-flex x-row-right x-p-r-10">
                <div>新密码</div>
              </div>
              <div class="x-flex-1 x-w100p">
                <el-input v-model="newPassword" placeholder="" show-password></el-input>
              </div>
            </div>
            <!-- 确认密码 -->
            <div class="x-w100p x-h42 x-p-b-10 x-d-flex x-lh-32">
              <div class="x-w70 x-d-flex x-row-right x-p-r-10">
                <div>确认密码</div>
              </div>
              <div class="x-flex-1 x-w100p">
                <el-input v-model="confirmPassword" placeholder="" show-password></el-input>
              </div>
            </div>
            <!-- 确定&取消 -->
            <div class="x-w100p x-h32 x-d-flex x-lh-32 x-row-right">
              <xButton width="70px" class="x-p-l-10" border="1px solid #DCDFE6" bgc="#fff" color="#242424"
                @click.native="changePassword = false">取消</xButton>
              <xButton width="70px" class="x-p-l-10" @click.native="determineAdd">确定</xButton>
            </div>
          </div>
        </el-dialog>
        <!-- 主体 -->
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  // json数据
  // import introduceNavList from '@/assets/StaticResources/menu.json';
  import introduceNavList from '@/assets/StaticResources/menuG.js';
  import cyNav from '@/assets/StaticResources/cyNav.js';
  import smsRecharge from '../components/smsRecharge.vue'
  export default {
    components: {
      smsRecharge
    },
    data() {
      return {
        smsRechargePop: false,
        active: '',
        //主菜单选中id
        navActSelId: '11',
        lastNavACt: '', //上一次点击的主菜单Id
        //移入事件触发时所在的主菜单
        hoverActive: '',
        //默认展开 节省性能不去遍历，后续如果增加可手动添加 或者使用fGetOpends函数
        openeds: [
          "1001",
          "1102",
          "1101",
          "1201",
          "1301",
          "1302",
          "1303",
          "1401",
          "1402",
          "1403",
          "1501",
          "1502",
          "1503",
          "1601",
          "1701",
          "1702",
          "1703",
          "1704",
          "1801",
          "1901",
          "2001",
          "2003",
          "2004",
          "1101",
          "1201",
          "1301",
          "1302",
          "1303",
          "1401",
          "1402",
          "1501",
          "1601",
          "1602",
          "1603",
          "1701",
          "1702",
          "1703",
          "1801",
          "1901",
          "1902",
          "1903",
          "1904",
          "2001",
          "2101",
          "1101",
          "1201",
          "1301",
          "1302",
          "1303",
          "1401",
          "1402",
          "1501",
          "1502",
          "1601",
          "1602",
          "1603",
          "1701",
          "1702",
          "1703",
          "1801",
          "1802",
          "1803",
          "1901",
          "1902",
          "1903",
          "1904",
          "2001",
          "2101",
          "1200",
          "1300",
          "1400",
          "1500",
          "1600",
          "1700",
          "1900",
          "2000",
          "2201",
          "2202",
          "2301",

        ],
        //浮动子菜单数据
        floatSubNavList: [],
        //窗口大小
        screenWidth: document.body.offsetWidth,
        //固定子菜单数据
        fixSubNavList: [],
        //浮动子菜单标题
        floatSubTitle: '',
        //固定子菜单标题
        fixSubTitle: '',
        //侧边栏==点击显示子菜单
        clickDisplaySub: false,
        //侧边栏==移入显示子菜单
        moveDisplaySub: false,
        // 面包屑导航
        breadcrumb: '', //一级面包屑
        breadcrumbPath: '', //一级面包屑跳转地址
        breadcrumbSub: '', //二级面包屑
        breadcrumbPath: '', //二级面包屑跳转地址
        // activeIndex: 0,
        // weizhi: 5,
        // 右边头部
        imagesA: require("../assets/img/administrators_C.png"),
        imagesB: require("../assets/img/headquarters_C.png"),
        //数据
        // navList: introduceNavList.nav,
        navList: this.$store.state.softVer == '餐饮' ? cyNav.cyNav : introduceNavList.nav,
        //记录路由
        recordRoute: "",
        // 箭头旋转判断
        rotation: false,
        // 修改密码
        changePassword: false,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
    async created() {
      this.navList = this.$store.state.softVer == '餐饮' ? cyNav.cyNav : JSON.parse(JSON.stringify(introduceNavList
        .nav))
      if (this.$store.state.softVer != '餐饮' && this.$store.state.smSellAdmin.shMallId != '00010001') {
        this.navList.forEach((item, index) => {
          if (item.id === 22) {
            this.navList.splice(index, 1)
            // this.navList[index].data.forEach((subItem,subIndex) =>{
            //   if(subItem.id === 2202){
            //     this.navList[index].data.splice(subIndex,1)
            //   }
            // })
          }
        })
      }
      //获取面包屑导航数据
      this.eventBus.$on('fChangeBreadcrumb', (breadcrumbList) => {
        this.breadcrumb = breadcrumbList.breadcrumb
        this.breadcrumbPath = breadcrumbList.path
        this.breadcrumbSub = breadcrumbList.breadcrumbSub
      })
      //获取面包屑导航数据
      this.eventBus.$on('fRouteFail', () => {
        this.fSetActive('return')
      })
      // 默认显示主菜单的第一个
      // this.navListClick(this.navList[0])
      // 默认展开
      // this.fGetOpends(this.navList)
      // 默认显示子菜单 == 显示固定页面
      if (document.body.offsetWidth < 1280) {
        this.clickDisplaySub = false;
      } else {
        this.clickDisplaySub = true;
      }
      //刷新时获取导航选中
      this.fSetActive()
    },

    mounted() {
      const that = this;
      window.onresize = () => (() => {
        window.screenWidth = document.body.offsetWidth;
        that.screenWidth = window.screenWidth;
      })();
    },

    watch: {
      '$route': 'getPathFn', //监听路由变化
      moveDisplaySub(newVal) {
        if (document.body.offsetWidth < 1280) {
          this.clickDisplaySub = false;
        } else {
          this.clickDisplaySub = true;
        }
      },
      screenWidth(val) {
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
        if (!this.timer) {
          // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
          this.screenWidth = val;
          this.timer = true;
          const that = this;
          setTimeout(function() {
            that.reload(that.screenWidth); //窗口大小变化后执行的方法
            that.timer = false;
          }, 10);
        }
      },
    },
    methods: {
      //
      fGoDownLoad() {
        window.open('http://www.sanmipos.com/smgw/download.html')
      },
      // 用户登录后显示的信息
      clickxw() {
        this.rotation = !this.rotation
      },
      // 刷新面包屑导航及侧边导航
      getPathFn(val) {
        this.fSetActive()
      },
      // 面包屑跳转
      fBreadcrumbRoter() {
        if (this.api.smCom.fSmIsEmpty(this.breadcrumbPath)) {
          return
        }
        this.$router.push(this.breadcrumbPath)
        this.breadcrumbSub = ''
        this.breadcrumbPath = ''
      },

      // 鼠标进主菜单
      mouseover(navItem) {
        //浮动子菜单标题
        this.floatSubTitle = navItem.label
        // 主菜单 id
        this.navActSelId = navItem.id
        //浮动子菜单数据
        this.floatSubNavList = navItem.data;
        //固定子菜单数据
        if (this.fixSubNavList.length - 0 == 0) {
          //固定子菜单标题
          this.fixSubTitle = this.floatSubTitle
          this.fixSubNavList = this.floatSubNavList
        }
        //
        // 显示悬浮页面
        this.moveDisplaySub = true

      },
      //鼠标移入悬浮子菜单
      hoverMouseover() {
        this.hoverActive = this.floatSubTitle
      },
      //鼠标离开子菜单 隐藏悬浮子菜单
      mouseleave() {
        this.hoverActive = ''
        this.moveDisplaySub = false;
      },
      // 点击主菜单
      navListClick(navItemData) {
        //找到当前的子菜单的数据
        this.subNavItemClick(navItemData);
      },
      // 子菜单的点击事件
      async subNavItemClick(itemData, type) {
        let navId = itemData.id + '';
        //取子菜单的id 前两位 取主菜单id
        this.navActSelId = navId.substring(0, 2);
        // 设置主菜单和子菜单选中状态
        this.navList.map(async (item) => {
          if (item.id == this.navActSelId || item.id == itemData.id) {
            item.select = true
            this.floatSubNavList = item.data
            this.fixSubNavList = item.data
            // 默认展开
            // this.openeds = []
            this.fixSubNavList.forEach(item => {
              // 如果id大于4位说明点击子菜单
              if (String(itemData.id).length > 4) {
                item.children.forEach(item1 => {
                  if (item1.id == itemData.id) {
                    this.lookForAllId(this.navList)
                    item1.select = true
                    this.breadcrumb = item1.navTitle
                    this.lastNavACt = this.navActSelId
                  }
                  return
                })
              } else {
                // if (this.lastNavACt != this.navActSelId) {
                //   this.subNavItemClick(itemData.data[0].children[0])
                // }
              }
            })
            if (item.id == this.navActSelId) {
              this.floatSubTitle = item.label
              this.fixSubTitle = this.floatSubTitle
            }
            // if (this.recordRoute == 0) {
            //   // 记录路由
            //   this.recordRoute = itemData.path
            //   this.breadcrumbSub = ''
            //   this.breadcrumbPath = ''
            // } else {
            this.breadcrumbSub = ''
            this.breadcrumbPath = ''
            // 直接跳转
            if (type != 'return') {

              //判断权限
              let power = itemData.label
              // switch (itemData.label) {
              //   case '概况':
              //     power = '系统首页'
              //     break
              //   case '基础':
              //     power = '基础档案'
              //     break
              //   case '采购':
              //     power = '采购管理'
              //     break
              //   case '批发管理':
              //     power = '系统首页'
              //     break
              //   case '零售':
              //     power = '零售管理'
              //     break
              //   case '推广':
              //     power = '推广营销'
              //     break
              //   case '仓库':
              //     power = '仓库连锁'
              //     break
              //   case '财务':
              //     power = '财务管理'
              //     break
              //   case '系统':
              //     power = '系统设置'
              //     break
              //   case '商城':
              //     power = '商城'
              //     break
              //   case '供应商':
              //     power = '供应商档案'
              //     break

              // }
              if (power != '电子会员' && power != "基础导航" && power != '我的桌面' &&
                power != "基础导航" && power != "采购导航" && power != "零售导航" && power != "会员导航" &&
                power != "批发导航" && power != "仓库导航" && power != "财务导航" && power != "商城导航") {
                let resPower = await this.api.smCommon.fGetSmMenuQx(power)
                if (resPower.resolve == false) {
                  this.fSetActive()
                  return this.$message('没有' + power + '的权限')
                }
              }
              if ((power == '电子价签' || power == '价签商品') && this.api.smCom.fSmIsEmpty(this.$store.state
                  .smSellAdmin.elabelMchId)) {
                this.fSetActive()
                return this.$message('暂未绑定价签商户')
              }
              this.$router.push(itemData.path);
            }
            // }
          } else {
            item.select = false
          }
        });

      },
      //设置选中状态
      fSetActive(type) {

        let isRotuer = type
        // 获取地址栏中的路由
        let defaultMenu = window.location.hash.substr(
          window.location.hash.indexOf("/")
        );
        this.activerouter = defaultMenu.split('?')[0].slice(1);
        // 取前缀
        if (this.activerouter.split('_')[0].length > 1) {
          this.activerouter = this.activerouter.split('_')[0]
          isRotuer = 'return'
        }
        // 设置主菜单和子菜单选中状态
        let data = []
        this.navList.forEach((item) => {
          item.data.forEach(item1 => {
            item1.children.forEach(item2 => {
              if (item2.path == this.activerouter) {
                data = item2
                this.breadcrumb = item2.kghas
                return
              }
            })
          })
        });
        this.subNavItemClick(data, isRotuer)
      },
      //导航自适应
      reload(screewidth) {
        if (screewidth < 1280) {
          this.clickDisplaySub = false;
        } else {
          this.clickDisplaySub = true
        }
      },
      //导航数据遍历 用于清除其他选中 保证一棵树只有一个select
      lookForAllId(data = []) {
        for (let item of data) {
          if (String(item.id).length > 4) {
            item.select = false
          }
          if (item.data && item.data.length) {
            this.lookForAllId(item.data)
          }
          if (item.children && item.children.length) {
            this.lookForAllId(item.children)
          }
        }
      },
      // 获取所有需要展开的节点
      // fGetOpends(data = []) {

      //   for (let item of data) {
      //     if (String(item.id).length == 4) {
      //       this.openeds.push(String(item.id))
      //     }
      //     if (item.children && item.children.length) {
      //       this.fGetOpends(item.children)
      //     }
      //     if (item.data && item.data.length) {
      //       this.fGetOpends(item.data)
      //     }
      //   }
      // },

      // 修改密码==打开
      Change() {
        this.changePassword = true
      },
      // 修改密码=确定
      async determineAdd() {
        if (this.newPassword == this.confirmPassword) {
          let res = await this.fUserChgPsw()
          if (res.msg == "请输入正确的原始密码") {
            this.$message(res.msg);
          } else if (res.msg == "修改密码成功") {
            this.$message(res.msg);
            this.changePassword = false
            this.fLoginOut()
          }
        } else {
          this.$message('确认密码与修改的密码不一至！');
        }
      },
      //退出登录
      fLoginOut() {
        this.$router.replace('login')
      },
      fSendMqtt() {

        this.$confirm('将通知所有设备端信息更新', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.fSendMqttCmd()
          this.$message(res.msg)
          if (res.result != 'sucess') {
            return
          }
        }).catch(() => {});
        return

      },
      // ========请求开始========
      // 修改密码  USER_CHG_PSW
      async fUserChgPsw(oper) {
        let js = {};
        js['USER_ID'] = this.$store.state.smSellAdmin.userId
        js['OLD_PSW'] = this.oldPassword
        js['NEW_PSW'] = this.newPassword
        let res = await this.api.smSellApi.fPostToSmSellAdminApi('USER_CHG_PSW', js)
        return res;
      },
      async fSendMqttCmd(oper) {
        let js = {};
        js['OPER'] = 'SMSELL_DATA_UPDATE'
        js['MALL_ID'] = this.$store.state.smSellAdmin.shMallId
        js['MSG_TYPE'] = 'smSellDataUpdate'
        js['DATA'] = ''
        console.log(js)
        let res = await this.api.newSmApi.fPostToAdminApi({
          sMethodName: 'SEND_MQTT_CMD',
          reqJson: js
        })
        console.log(res)
        return res;
      },
      //=======请求结束========
    },

  };
</script>

<style lang="less" scoped>
  .bgc-0 {
    background-color: #000;
  }

  /deep/.vxe-table--render-default .vxe-body--row.row--stripe {
    background-color: #fafbfc;
  }

  //取消单元格选中样式
  /deep/.vxe-table--render-default .vxe-body--column.col--selected {
    box-shadow: unset;
  }

  .home-page {

    // 箭头旋转
    .rotate {
      transition: transform .3s, -webkit-transform .3s;
      transform: rotateZ(-180deg);
    }

    .rotates {
      transition: transform .3s, -webkit-transform .3s;
      transform: rotateZ(0deg);
    }

    // 穿透
    // /deep/ .el-tree-node__content {
    //   height: 40px;
    //   color: #999;
    // }

    // 重置弹框样式
    /deep/ .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog__body {
      padding: 0 !important;
    }

    //面包屑可点击状态
    .breadcrumbHover {
      cursor: pointer;
      color: #6C9CFC;
    }

    //主菜单
    .main-menu {
      width: 89px;
      height: 100%;
      //

      .main-menu-top-level {
        height: calc(100vh - 46px);
        overflow-y: scroll;
        // width: 105px;
        padding-left: 0px;

        .infinite-list {
          .infinite-list-item {
            width: 100%;
            text-indent: 30px;
            line-height: 48px;
            line-height: 48px;
            color: #c9d7ec;
            cursor: pointer;
            position: relative;

            .block-element {
              display: inline-block;
              position: absolute;
              left: 10px;
              top: 0px;
              text-indent: 0px;
            }
          }

          .infinite-list-item:hover {
            background-color: #333e50;
            color: #fff;
          }

          .main-menu-style {
            background-color: #333e50;
            color: #fff;
          }
        }
      }

    }

    //主体
    .el-container {
      background-color: #f2f4f6;
      height: 100vh;
      overflow-y: hidden;

      //
      .el-aside {
        // background-color: #2a4266;
        color: white;
        height: 100%;
        overflow: visible;
        // overflow-x: hidden;
      }
    }

    //路由页面
    .el-main {
      overflow-y: hidden;
      padding: 10px;
    }

    //element-ui 选择器三角
    /deep/.el-select__caret {
      line-height: 32px;
    }

    // 选择行高
    /deep/.el-input__icon {
      line-height: 32px;
    }

    //所有表头背景颜色
    /deep/.vxe-table {
      .vxe-table--header-wrapper {
        background: #F5F7FA !important;
      }
    }

    //element 按钮样式==颜色
    /deep/.el-button--primary {
      background-color: #6396FC;
      border-color: #6396FC;
    }

    // 页选择的背景颜色
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #6396FC;
    }

    //单选文字颜色
    /deep/.el-radio__input.is-checked+.el-radio__label {
      color: #6396FC;
    }

    //单选按钮颜色
    /deep/.el-radio__input.is-checked .el-radio__inner {
      border-color: #6396FC;
      background: #6396FC;
    }

    //图片样式
    img {
      vertical-align: baseline;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue